<template>
    <section class="ins028" :style="dBHeight">
        <h1 class="hide">나의 공간 홈</h1>
        <div class="main_header_outer">
            <div class="main_header_comment clear">
                <div class="tit">{{ $i18nUtil.trans("message.userName","{user} 님", {user: userName})}}<br> <b>{{ $i18nUtil.trans("message.Mypage.001","일주일 간 업데이트된 나의 보드를 관리해보세요.") }}</b></div>
                <div class="main_header_count clear">
                    <ul>
                        <li>
                            <!-- <b>{{sharedBoardCount}}</b>
                            <span>공유 받은 보드</span> -->
                        </li>
                    </ul>
                </div>
            </div>
        </div><!-- main_header_outer -->

        <!-- 프라이빗 보드 목록 start -->
        <div class="division">
            <div class="sub_tit_box clear">
                <h3 class="fl">{{ $i18nUtil.trans("entity.cogroup.groupKbn.user","프라이빗") }}</h3>
                <router-link :to="{ name: 'private' }">
                    <button type="button" class="btn-more-ico_small1 down right fr">{{ $i18nUtil.trans("button.Mypage.001", "프라이빗 보기") }}</button>
                </router-link>
            </div>
            <swiper :options="swiperOption" ref="mySwiper" class="list-card_square col-4" v-if="privateBoardList.length > 0">
                <!-- slides -->
                <swiper-slide class="clear" v-for="(privateBoard, index) in privateBoardList" :key="'private' + index">
                    <div class="list-top">
                        <div class="list-top clear">
                            <div class="btn_top hover fr">
                                <!-- <button type="button" class="ico-switch_favorites active" @click="$event.target.classList.toggle('active');">즐겨찾기</button> -->
                                <button 
                                    type="button" 
                                    class="ico-switch_favorites active"
                                    v-show="privateBoard.paperBookmarkId != null" 
                                    @click="toggleBookmark(privateBoard)"
                                >
                                    즐겨찾기
                                </button>
                                <button 
                                    type="button" 
                                    class="ico-switch_favorites"
                                    v-show="privateBoard.paperBookmarkId == null"
                                    @click="toggleBookmark(privateBoard)"
                                >
                                    즐겨찾기
                                </button>
                            </div>
                        </div>
                    </div>
                    <router-link :to="{ name: 'board', params: {paperId : privateBoard.paperId} }">
                        <div class="list-tit-s multi-ellipsis ell-multiline2"
                            @mouseenter="mouseEvt(true, privateBoard, $event)"
                            @mouseleave="mouseEvt(false, privateBoard, null)"
                        >
                        {{privateBoard.paperTitle}}
                        </div>
                    </router-link>
                    <div class="list-btm clear">
                        <div class="member-list fl" v-if="privateBoard.paperUserCount > 999">
                            {{ $i18nUtil.getLanguage() !== 'ko' && privateBoard.lastUpdUserNameEn != null ? privateBoard.lastUpdUserNameEn : privateBoard.lastUpdUserName }} <b>999+</b>
                        </div>
                        <div class="member-list fl" v-else>
                            {{ $i18nUtil.getLanguage() !== 'ko' && privateBoard.lastUpdUserNameEn != null ? privateBoard.lastUpdUserNameEn : privateBoard.lastUpdUserName }} <b>{{privateBoard.paperUserCount}}</b>
                        </div>
                        <div class="list-date fr">
                            <!-- 24시간 이내-->
                            <momentAgo v-if="checkHours(privateBoard.lastUpdDate)" prefix="" suffix="전" :date="privateBoard.lastUpdDate" lang="kr"></momentAgo>
                            <!-- 24시간 이후-->
                            {{ !checkHours(privateBoard.lastUpdDate) ? privateBoard.lastUpdDate.substring(0,10).replace("-", ".").replace("-", ".") : '' }}
                            <span v-if="privateBoard.readCount == null || privateBoard.readCount == 0" class="ico-new"></span>
                        </div>
                    </div>
                    <div class="tooltip-b tl small" style="z-index: 11; display: none;" :id="privateBoard.paperId+'_tooltip'">
                        <!-- tooltip -->
                        {{ privateBoard.paperTitle }}
                    </div>
                </swiper-slide>
                <div class="swiper-button-prev" slot="button-prev">prev</div>
                <div class="swiper-button-next" slot="button-next">next</div>
            </swiper>
            <!-- 프라이빗 보드 목록 end -->
            <div class="nodata" v-if="privateBoardList.length === 0">
                <div>
                    <div class="txt">{{ $i18nUtil.trans("message.Mypage.002","프라이빗 보드를 등록하여 관리해보세요.") }}</div>
                    <button type="button" class="btn-primary-smaller black" @click="createBoard">{{ $i18nUtil.trans("button.paper.user.add", "프라이빗 보드 추가") }}</button>
                </div>
            </div>
            <!-- 공유받은 보드 목록 start -->
            <div class="sub_tit_box clear">
                <h3 class="fl">{{ $i18nUtil.trans("message.Mypage.003","공유받은 보드") }}</h3>
                <router-link :to="{ name: 'cooperationMemberBoard' }">
                    <button type="button" class="btn-more-ico_small1 down right fr">{{ $i18nUtil.trans("button.Mypage.002", "보드 보기") }}</button>
                </router-link>
            </div>
            <swiper :options="swiperOption" ref="mySwiper" class="list-card_square col-4" v-if="sharedBoardList.length > 0">
                <!-- slides -->
                <swiper-slide class="clear" v-for="(shareBoard, index) in sharedBoardList" :key="'share' + index">
                    <div class="list-top">
                        <div class="list-top clear">
                            <div class="btn_top hover fr">
                                <button 
                                    type="button" 
                                    class="ico-switch_favorites active"
                                    v-show="shareBoard.paperBookmarkId != null" 
                                    @click="toggleBookmark(shareBoard)"
                                >
                                    즐겨찾기
                                </button>
                                <button 
                                    type="button" 
                                    class="ico-switch_favorites"
                                    v-show="shareBoard.paperBookmarkId == null"
                                    @click="toggleBookmark(shareBoard)"
                                >
                                    즐겨찾기
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="list-tit-s multi-ellipsis ell-multiline2"
                        @mouseenter="mouseEvt(true, shareBoard, $event)"
                        @mouseleave="mouseEvt(false, shareBoard, null)"
                    >
                        <router-link :to="{ name: 'board', params: {paperId : shareBoard.paperId} }">
                        {{shareBoard.paperTitle}}
                        </router-link>
                    </div>
                    <div class="list-btm clear">
                        <div class="member-list fl" v-if="shareBoard.paperUserCount > 999">
                            {{ $i18nUtil.getLanguage() !== 'ko' && shareBoard.lastUpdUserNameEn != null ? shareBoard.lastUpdUserNameEn : shareBoard.lastUpdUserName }} <b>999+</b>
                        </div>
                        <div class="member-list fl" v-else>
                            {{ $i18nUtil.getLanguage() !== 'ko' && shareBoard.lastUpdUserNameEn != null ? shareBoard.lastUpdUserNameEn : shareBoard.lastUpdUserName }} <b>{{shareBoard.paperUserCount}}</b>
                        </div>
                        <div class="list-date fr">
                            <!-- 24시간 이내-->
                            <momentAgo v-if="checkHours(shareBoard.lastUpdDate)" prefix="" suffix="전" :date="shareBoard.lastUpdDate" lang="kr"></momentAgo>
                            <!-- 24시간 이후-->
                            {{ !checkHours(shareBoard.lastUpdDate) ? shareBoard.lastUpdDate.substring(0,10).replace("-", ".").replace("-", ".") : '' }}
                            <span v-if="shareBoard.readCount == null || shareBoard.readCount == 0" class="ico-new"></span>
                        </div>
                    </div>
                    <div class="tooltip-b tl small" style="z-index: 11; display: none;" :id="shareBoard.paperId+'_tooltip'">
                        <!-- tooltip -->
                        {{ shareBoard.paperTitle }}
                    </div>
                </swiper-slide>
                <div class="swiper-button-prev" slot="button-prev">prev</div>
                <div class="swiper-button-next" slot="button-next">next</div>
            </swiper>
            <div class="nodata" v-if="sharedBoardList.length === 0">
                <div>
                    <div class="txt">{{ $i18nUtil.trans("message.Mypage.004","공유받은 보드가 없습니다.") }}</div>
                </div>
            </div>
            <!-- 공유받은 보드 목록 end -->
        </div>
    <modals-container @registBoard="registBoard"/>
    </section>
</template>

<script>
import Vue from 'vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper, /* { default global options } */)
// Navigation error로 아래 내용으로 대체
import {Swiper as SwiperClass, Scrollbar, Navigation} from 'swiper/swiper.esm.js'
import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter'
// Swiper modules
SwiperClass.use([Scrollbar, Navigation])
// local component
const {directive} = getAwesomeSwiper(SwiperClass)
import { mapState, mapActions } from "vuex";
import axios from "axios";
import SockJS from "sockjs-client";
import Stomp from "webstomp-client";
import UserInfo from "@/components/cowork/common/user/UserInfo";
import UserTooltip from "@/components/cowork/common/user/UserTooltip";
import RegistBoardModal from "@/components/cowork/general/board/modal/RegistBoardModal";
export default {
    directives: {
        swiper: directive
    },
    data() {''
        return {
            dBHeight: {
                'min-height': (window.innerHeight) + 'px',
            },
            userName : null,
            privateBoardList : [],
            sharedBoardList : [],
            toastInfo: {
                obj: this.$toasted,
                message: "",
                options: {
                    theme: "toasted-primary",
                    position: "bottom-left",
                    duration: 3000,
                },
            },
            swiperOption: {
                slidesPerView: 4,
                spaceBetween: 20,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            }
        }
    },
    components : {
        UserInfo,
        UserTooltip
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.swiper
        }
    },
    mounted() {
        this.connect();
        this.init();

        // 뒤로가기 이벤트 발생시 .
        const self = this;
        window.onpopstate = function (event) {
            let returnUrls = localStorage.getItem("returnUrls");
            if(returnUrls != null) {
                let urlList = returnUrls.split(",");
                if (urlList.length > 0) {
                    if (urlList.length == 1) {
                        localStorage.removeItem("returnUrls");
                        // self.$router.push("/general/home");
                    } else {
                        urlList.pop();
                        urlList.pop();
                        localStorage.setItem("returnUrls", urlList);
                        // this.$router.replace(urlList[urlList.length-1]);
                    }
                } else {
                    self.$router.push("/general/home");
                }
            }else{
                self.$router.push("/general/home");
            }
        }
    },
    beforeDestroy() {
        try { this.stompClient.disconnect(() => {}); } catch (ignore) { }
        try { this.socket.close(); } catch (ignore) { }
        this.connected = false;
    },
    methods : {
        ...mapActions("modals", ["showDialog"]),
        ...mapActions("modals", ["showModal", "showToast"]),
        ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION", "COWORK_REST_ALL_ACTION"]),

        /* 말줄임(...) 시, tooltip 적용 */
        mouseEvt(flag, element, event) {
            if(flag) {
                // 말줄임(...) css 적용 여부 체크 (boolean)
                let val = this.$tooltip.hasOverflownHeight(event.target);

                if(val) {
                    document.getElementById(element.paperId+'_tooltip').style.display = 'block';
                }else{
                    document.getElementById(element.paperId+'_tooltip').style.display = 'none';
                };
            }else{
                document.getElementById(element.paperId+'_tooltip').style.display = 'none';
            }
        },
        connect() {
            let serverUrl = "/api/copaper/websocket";
            this.socket = new SockJS(serverUrl, null, {transports: ["websocket"]});
            this.socket.protocol = 'v12.stomp';
            this.stompClient = Stomp.over(this.socket);
            this.stompClient.heartbeat.outgoing = 20000;
            this.stompClient.heartbeat.incoming = 0;
            this.stompClient.reconnect_delay = 5000;
            this.stompClient.debug = (msg) => {
                //console.log("SOCK:", msg);
            };
            this.stompClient.connect(
                { Authorization: localStorage.getItem("Authorization") },
                (frame) => {
                    this.connected = true;
                    this.subsCribe();
                },
                (error) => {
                    console.log(error);
                    this.connected = false;
                }
            );
        },
        subsCribe() {
            let obj = this;
            let subChannel = "/api/copaper/topic/paperShare/subscribe/" + localStorage.getItem("userId");
            obj.stompClient.subscribe(
                subChannel,
                (message) => {
                    obj.init();
                }
            );
        },
        init() {
            this.userName = localStorage.getItem("userName");
            /* 프라이빗 보드 목록 조회 */
            this.getPrivateBoardList();
            /* 공유받은 보드 목록 조회 */
            this.getSharedBoardList();
        },
        /* 프라이빗 보드 목록 조회 */
        getPrivateBoardList() {
            let obj = this;
            let reqData = {
                url: "/api/copaper/paper/getPrivatePaperList",
                method: "post",
                params: {
                    limitRow : "20"
                }
            };
            obj
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then(function(res) {
                if(res.errorCode !== null) {

                } else {
                    if(res.result !== null) {
                        obj.privateBoardList = res.result;
                        obj.multiElipsis(2);
                    }
                }
            })
            .catch(function(err){
                console.log(err);
            });
        },
        /* 공유받은 보드 목록 조회 */
        getSharedBoardList() {
            let obj = this;
            let reqData = {
                url: "/api/copaper/paper/getCooperationMemberBoardList",
                method: "post",
                params: {}
            };
            obj
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then(function(res) {
                if(res.errorCode !== null) {

                } else {
                    if(res.result !== null) {
                        obj.sharedBoardList = res.result;
                        obj.multiElipsis(2);
                    }
                }
            })
            .catch(function(err){
                console.log(err);
            });
        },
        /* 시간체크 */
        checkHours(lastUpdated) {
            let now = this.$moment()
            let before24hours = this.$moment().subtract(1,'days')
            let lastUpdatedTime = this.$moment(lastUpdated)
            
            if(lastUpdatedTime.isBetween(before24hours, now)) {
                // 24시간 이내
                return true;
            }else{
                // 24시간 이후
                return false;
            }
        },
        /* 즐겨찾기 설정/해제 */
        toggleBookmark(board) {
            let obj = this;
            let reqData = {
                url : "/api/copaper/bookmark/savePaperBookmark",
                method : "post",
                params : {
                    paperId: board.paperId,
                    bookmarkId:board.paperBookmarkId
                }
            }
            obj.showLoadingbar();
            obj
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then(res => {
                board.paperBookmarkId = res.result;
                if(board.paperBookmarkId != null) {
                    obj.toastInfo.message = obj.$i18nUtil.trans('TB041', '즐겨찾기가 설정되었습니다.');
                    obj.showToast(obj.toastInfo);
                } 
                else {
                    obj.toastInfo.message = obj.$i18nUtil.trans('TB042', '즐겨찾기가 해제되었습니다.');
                    obj.showToast(obj.toastInfo);
                }
                obj.hideLoadingbar();
            }) 
            .catch(function(err) {
                obj.showLoadingbar(false);
                console.log(err);
            });
        },
        /* 보드 만들기 모달 호출 */
        createBoard() {
            let obj = this;
            let reqData = {
                url : "/api/copaper/paper/getGeneratedPaperId",
                method : "post",
                params: {
                    deptId: null,
                    parentDeptId: null,
                },
            };
            obj
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then(function (res) {
                let errorCode = res.errorCode;
                let addPaperId = res.result;
                const modalInfo = {
                    title: obj.$i18nUtil.trans("title.RegistBoardModal.000","업무보드 추가"),
                    name: "registBoard",
                    method: "post",
                    width: "800px",
                    // height: "493px",
                    obj: obj.$modal,
                    paperId: addPaperId,
                    categoryMid: null,
                    groupId: null,
                    paperTitle: "",
                    contentPath: "",
                    docGrade: "SECRET",
                    component: RegistBoardModal,
                };
                obj.showModal(modalInfo);
            })
            .catch(function (err) {
                console.log(err);
            });
        },
        /* 보드 생성 API 호출 */
        registBoard(_data) {
            let obj = this;
            let reqData = {
                url : "/api/copaper/paper/addPaper",
                method : "post",
                params: {
                    paperTitle : _data.paperTitle, 
                    paperId: _data.paperId, 
                    groupId : _data.groupId, 
                    categoryMid : _data.categoryMid, 
                    contentPath : _data.contentPath, 
                    docGrade: "SECRET", 
                    blockType: "CONTENT",
                    tagList: _data.tagList,
                    link:"/general/board/" + _data.paperId,
                },
            };
            obj.showLoadingbar();
            obj
            .COWORK_REST_ALL_ACTION(reqData)
            .then(res => {
                obj.hideLoadingbar();
                if(res.errorCode != null) {
                    return;
                }
                let newBoard = JSON.parse(res.config.data)
                newBoard = newBoard.paperId;
                obj.toastInfo.message = obj.$i18nUtil.trans("TB036", '보드가 저장되었습니다.');
                obj.showToast(obj.toastInfo);
                obj.$router.push('/general/board/' + newBoard);
            })
            .catch(function(err) {
                console.log(err);
            })
        },
        multiElipsis(ellipsisLine) {
            this.$nextTick(function(){
                let selecter = "multi-ellipsis";
                var omle = document.getElementsByClassName(selecter); 
                for(let item of omle){
                    if (item.scrollHeight > 55) {
                        item.classList.remove("no-ellipsis");
                    } else {
                        item.classList.add("no-ellipsis");
                    }
                }  
            })
        }, 
    }
};
</script>

<style scoped>
.multi-ellipsis {
  overflow: hidden;
  position: relative;
  line-height: 1.44;
  text-align: justify;
  text-overflow: ellipsis;
  word-wrap: break-word;
  word-break: break-all;
}
.multi-ellipsis:before,
.multi-ellipsis:after {
  content: "...";
  line-height: 1;
  position: absolute;
  right: 0;
  top: 1.44em;
  -ms-wrap-flow: start;
}
.multi-ellipsis:after {
  background: currentColor !important;
  color: #fff !important;
  top: auto;
}
.multi-ellipsis.no-ellipsis::before,
.multi-ellipsis.no-ellipsis::after {
  display: none;
}
@supports (-webkit-line-clamp: 2) {
  .multi-ellipsis {
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .multi-ellipsis::before,
  .multi-ellipsis::after {
    content: normal;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/general/mypage/base/Mypage.vue